import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: Theme) => {
  const ACTION_BAR_HEIGHT = 80;
  return {
    root: {
      width: '100%',
      justifyContent: 'flex-end',
      alignItems: 'center',
      display: 'flex',
      minHeight: ACTION_BAR_HEIGHT,
      borderTop: `1px solid ${theme.palette.divider}`
    },
    nextButton: {
      marginRight: theme.spacing(6)
    },
    cancelButton: {
      marginRight: theme.spacing(3)
    }
  };
});

interface StepActionsProps {
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
  confirmText: string;
  cancelText: string;
  onCancel: React.MouseEventHandler<HTMLButtonElement>;
  disableConfirm?: boolean;
}
const StepActions: React.FC<StepActionsProps> = ({
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  disableConfirm
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Button
        aria-label="Cancel Classroom Create"
        className={classes.cancelButton}
        onClick={onCancel}
        variant="outlined"
        color="secondary"
        disableElevation
      >
        {cancelText}
      </Button>
      <Button
        aria-label={'Step Forward'}
        className={classes.nextButton}
        onClick={onConfirm}
        disabled={disableConfirm}
        variant="contained"
        color="primary"
        disableElevation
      >
        {confirmText}
      </Button>
    </div>
  );
};

export default StepActions;
